import {Config} from "./config";
import {getUserIdentity} from "./api/userIdentity";
import {init as initRecodingView} from "./view/recording";
import {init as clockUI} from "./view/clock";
import "web-audio-recorder/lib/WebAudioRecorder"
import Api from "./api/api";

export function _initRecorder(api: Api,{timeLimit, controls, cookie}: Config, fnAdd: (r: Recording) => void) {
    const encodingType = "mp3"
    const userId = getUserIdentity(cookie);
    const recordingView = initRecodingView(controls, startRecording, stopRecording, postRecording)
    const clockView = controls.clock && clockUI(timeLimit, controls.clock)
    recordingView.disableRecording(false);
    recordingView.disablePlayback();

    let recorder: WebAudioRecorder | null;
    let inStream: MediaStream | null = null;

    let lastRecording: Blob | null;


    function startRecording() {

       try{
           navigator.mediaDevices.getUserMedia({audio: true}).then(function (stream) {
               clockView && clockView.start();

               const audioContext: AudioContext = new (window.AudioContext || window.webkitAudioContext)();
               inStream = stream;
               const input: MediaStreamAudioSourceNode = audioContext.createMediaStreamSource(stream);
               // @ts-ignore
               recorder = new WebAudioRecorder(input, {
                   workerDir: "js/",
                   workerFileSuffix: ".min.js",
                   encoding: encodingType,
                   numChannels: 2, //2 is the default, mp3 encoding supports only 2
                   onEncoderLoading: function (recorder: any, encoding: string) {
                       console.log("Loading " + encoding + " encoder...");
                   },
                   onEncoderLoaded: function (recorder: any, encoding: string) {
                       console.log(encoding + " encoder loaded");
                   }
               });
               if (!recorder) throw Error() // hack because type def is not working
               recorder.onComplete = async function (recorder: WebAudioRecorder, blob: Blob) {
                   console.log("Encoding complete", blob.type);
                   lastRecording = blob;
                   recordingView.enablePlayback(blob)

               }
               recorder.setOptions({
                   timeLimit,
                   encodeAfterRecord: true,
                   ogg: {quality: 0.5},
                   mp3: {bitRate: 160}
               });
               recorder.startRecording();
               console.log("Recording started");
               recordingView.disableRecording(true);

               recordingView.disablePlayback();

               console.log("Recording started");
           })
       } catch (err) {
           alert(navigator.mediaDevices)
       }
    }

    function stopRecording() {
        clockView && clockView.stop();
        if (inStream)
            inStream.getAudioTracks()[0].stop();
        recordingView.disableRecording(false);
        if (recorder) recorder.finishRecording();
    }

    function postRecording(author: string | undefined) {
        console.log("posting recording");
        if (!lastRecording) throw Error("State problem, posting recording, when no lastRecording has been set")
        api.add({
            author: author,
            authorId: userId
        }, lastRecording).then(r=>r && fnAdd(r))
        recordingView.disablePlayback()
    }
}
